var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-side"},[_c('AuthHeader',{attrs:{"logo":require('@/assets/registration/logo.png')}}),_c('div',{staticClass:"content"},[_c('ForgotPassForm')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }